module.exports = __webpack_public_path__ + "booking-fav-icon.png?46b13e9c8b7be7c03591ebaad21aedc2";